export const QUERY_KEYS = {
  BACKOFFICE_USER: 'backofficeUser',
  TEAMS: 'teams',
  MINIGOLS: 'minigols',
  NOTIFICATIONS: 'notifications',
  AWARDS: 'awards',
  TRANSFERLIST: 'transferList',
}
